import { render, staticRenderFns } from "./order-filter-tag.vue?vue&type=template&id=8d4c7a34&scoped=true&"
import script from "./order-filter-tag.component.ts?vue&type=script&lang=ts&"
export * from "./order-filter-tag.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-filter-tag.scss?vue&type=style&index=0&id=8d4c7a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4c7a34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d4c7a34')) {
      api.createRecord('8d4c7a34', component.options)
    } else {
      api.reload('8d4c7a34', component.options)
    }
    module.hot.accept("./order-filter-tag.vue?vue&type=template&id=8d4c7a34&scoped=true&", function () {
      api.rerender('8d4c7a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery/components/order-filter-tag/order-filter-tag.vue"
export default component.exports